<script>
import dialog2Mixin from "../mixins/dialog2";
import { authComputed } from "@store/helpers";
import { memberPetOptions } from "@utils/ipetbooking-options";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      petId: '',
      submitData: {
        petId: ''
      }
    }
  },
  computed: {
    ...authComputed,
    petList() {
      return memberPetOptions()
    }
  },
  mounted() {
    const initSubmitData = () => {
      this.submitData.petId = this.petId;
    };

    initSubmitData();
    this.tryToFetchMemberPetList();
  },
  methods: {
    tryToFetchMemberPetList() {
      this.$store.dispatch('auth/fetchMemberPetList', {
        limit: 100,
        useCached: true,
      })
    },
    onSubmit() {
      this.$router.push({
        name: 'prepaid-reservation',
        query: {
          petId: this.submitData.petId
        }
      });

      this.$Dialog2MixinOnDestroy();
    },
    openDialogPet() {
      this.$globalDialog('DialogPet', {
        type: 'add',
        callbackNewPet: (submitData) => {
          this.submitData.petId = submitData.id;
        }
      })
    },
    onSkip() {
      this.$router.push({
        name: 'prepaid-reservation'
      });

      this.$Dialog2MixinOnDestroy();
    },
  }
}
</script>
<template>
  <el-dialog
    width="582px"
    :class="[$style.dialogSelectPetJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
    :visible.sync="dialog2MixinVisible"
    append-to-body
    custom-class="isStyleBase"
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogSelectPetJtails__title mb-4">{{ $t('site.SELECT_PREPAID_USER') }}</div>
    <el-skeleton
      :loading="$isLoading('fetchMemberPetList') && petList.length === 0"
      animated
      :throttle="300"
    >
      <template slot="template">
        <div :class="$style.skeletonList">
          <el-skeleton-item
            v-for="n in 4"
            :key="n"
            class="skeletonList__item"
          ></el-skeleton-item>
        </div>
      </template>
      <template>
        <template v-if="petList.length === 0 && !$isLoading('fetchMemberPetList')">
          <BaseNull
            :title="`尚未新增${$t('site.USER')}`"
            class="mb-5"
          >
          </BaseNull>
        </template>
        <div v-else class="dialogSelectPetJtails__petList">
          <el-radio-group

            v-model="submitData.petId"
            class="isStylePet"
          >
            <el-radio
              v-for="(petItem, index) in petList"
              :key="`petList-${index}`"
              :label="petItem.id"
            >

              <div
                class="el-radio__image"
                :style="{ backgroundImage: `url('${ petItem.avatar || require(`@assets/images/${$globalProjectName}/reservation/pet-avatar-default@2x.png`) }')` }"
              >

              </div>
              <div class="el-radio__contentBox">
                <div class="el-radio__title">
                  {{ petItem.name }}
                </div>
                <div v-if="$globalCategoryVisible" class="el-radio__meta">
                  {{ petItem.categoryTitle }} | {{ petItem.sizeTitle }}
                </div>
              </div>
            </el-radio>
          </el-radio-group>
        </div>
<!--        {{ petList }}-->
      </template>
    </el-skeleton>
    <BaseButton
      :disabled="!submitData.petId"
      class="isStylePrimary isFull mb-3"
      :class="{
        'isRadius': $globalIsJtails,
      }"
      @click="onSubmit"
    >
      確認選取
    </BaseButton>
<!--    <BaseButton
      :disabled="invalid"
      :loading="$isLoading('storeMemberPet') || $isLoading('uploadMemberMedia') || $isLoading('deleteMemberMedia')"
      class="isStylePrimary isFull isRadius mb-3"
      type="submit"
    >
      確認選取
    </BaseButton>-->
    <BaseButton
      class="isStylePrimary isOutline3 isFull"
      :class="{
        'isRadius': $globalIsJtails,
      }"
      @click="openDialogPet"
    >
      我要新增{{ $t('site.USER') }}
    </BaseButton>
    <div class="text-center">
      <BaseButton
        class="isStylePrimary isTextUnderline2 mt-4 text-center"
        @click="onSkip"
      >
        略過
      </BaseButton>
    </div>
<!--    <BaseButton
      :disabled="!tempCoupon.code"
      class="isStylePrimary isFull isRadius mb-3"
      @click="onConfirm"
    >
      確認使用
    </BaseButton>-->
    <!--<BaseButton
      class="isStylePrimary isFull isRadius isOutline3"
      @click="$DialogMixinOnClose"
    >
      取消
    </BaseButton>-->
  </el-dialog>
</template>
<style lang="scss" module>
.dialogSelectPetJtails {
  :global {
    .dialogSelectPetJtails {
      &__title {
        @extend %FontSerifWeightJtails;

        font-size: 1.313rem;
        text-align: center;
      }

      &__petList {
        height: 421px;
        min-height: 300px;
        max-height: calc((var(--vh, 1vh) * 100) - 6vh - 390px);
        margin-bottom: 3rem;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .dialogSelectPetJtails {
        &__title {
          font-size: 1.125rem;
          font-family: unset;
          color: $color-secondary;
        }
      }
    }
  }
}

.skeletonList {
  height: 421px;
  margin-bottom: 3rem;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  :global {
    .skeletonList {
      &__item {
        display: flex;
        justify-content: space-between;
        height: 84px;
        padding: 1.5rem 1.875rem;
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
